var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"product"}},[_c('div',{staticClass:"ClueQuery"},[_c('van-nav-bar',{attrs:{"fixed":"","title":_vm.title,"left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('div',{staticClass:"fout-img"},[_c('img',{attrs:{"src":_vm.fourimg,"alt":""}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }